{
  "hnd": {
    "point_ja": "羽田空港",
    "lat": 35.5456993,
    "lon": 139.7890264,
    "spot_id": "41000131"
  },
  "nrt": {
    "point_ja": "成田国際空港",
    "lat": 35.7758917,
    "lon": 140.3835383,
    "spot_id": "41000207"
  },
  "kix": {
    "point_ja": "関西国際空港",
    "lat": 34.4344098,
    "lon": 135.2330813,
    "spot_id": "41000214"
  },
  "sapporo": {
    "point_ja": "札幌",
    "lat": 43.06194,
    "lon": 141.35444,
    "normal_point_id": "14163"
  },
  "sendai": {
    "point_ja": "仙台",
    "lat": 38.26806,
    "lon": 140.86944,
    "normal_point_id": "34392"
  },
  "kanazawa": {
    "point_ja": "金沢",
    "lat": 36.56125531,
    "lon": 136.656638,
    "normal_point_id": "56227"
  },
  "tokyo": {
    "point_ja": "東京",
    "lat": 35.69274831,
    "lon": 139.7505995,
    "normal_point_id": "44132"
  },
  "nagoya": {
    "point_ja": "名古屋",
    "lat": 35.18139,
    "lon": 136.90667,
    "normal_point_id": "51106"
  },
  "osaka": {
    "point_ja": "大阪",
    "lat": 34.69389,
    "lon": 135.50222,
    "normal_point_id": "62078"
  },
  "hiroshima": {
    "point_ja": "広島",
    "lat": 34.38528,
    "lon": 132.45528,
    "normal_point_id": "67437"
  },
  "takamatsu": {
    "point_ja": "高松",
    "lat": 34.34305072,
    "lon": 134.0465296,
    "normal_point_id": "72086"
  },
  "fukuoka": {
    "point_ja": "福岡",
    "lat": 33.59048822,
    "lon": 130.4018918,
    "normal_point_id": "82182"
  },
  "naha": {
    "point_ja": "那覇",
    "lat": 26.21228613,
    "lon": 127.6794654,
    "normal_point_id": "91197"
  }
}
